import { createApiFactory, createPlugin, createRoutableExtension, discoveryApiRef, fetchApiRef } from '@backstage/core-plugin-api';
import { EpDevPPluginIds } from '@solace-labs/backstage-plugin-ep-devp-common';
import { EpDevPConsumerProductsApiClient } from '@solace-labs/backstage-plugin-ep-devp-consumer-products-common';
import { EpDevPManageAppsApiClient } from '@solace-labs/backstage-plugin-ep-devp-manage-apps-common';
import { epDevPManageAppsApiRef, epDevPConsumerProductsApiRef } from './apis';
import { rootRouteRef } from "./routes";

export const epDevPManageAppsPlugin = createPlugin({
  id: EpDevPPluginIds.EpDevPManageAppsPluginId,
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: epDevPManageAppsApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new EpDevPManageAppsApiClient({
          discoveryApi: discoveryApi,
          fetchApi: fetchApi
        }),
    }),
    createApiFactory({
      api: epDevPConsumerProductsApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new EpDevPConsumerProductsApiClient({
          discoveryApi: discoveryApi,
          fetchApi: fetchApi
        }),
    }),
  ]
});

export const EpDevPManageAppsPage = epDevPManageAppsPlugin.provide(
  createRoutableExtension({
    name: 'EpDevPManageAppsPage',
    component: () => import('./components/Router').then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);

// export const EpDevPManageAppsApprovalsPage = epDevPManageAppsPlugin.provide(
//   createRoutableExtension({
//     name: 'EpDevPManageAppsApprovalsPage',
//     component: () => import('./components/approvals/ApprovalsRouter').then(m => m.ApprovalsRouter),
//     mountPoint: approvalsRootRouteRef,
//   })
// );
